/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { FeedbackDetailViewModel } from "../types/FeedbackDetailViewModel.ts";

export const feedbackDetailViewModelSchema = z.object({
  feedbackId: z.optional(z.number().int()),
  classroomDisciplineId: z.optional(z.number().int()),
  title: z.string().nullish(),
  type: z.optional(z.number().int()),
  typeText: z.string().nullish(),
  maxNumber: z.number().int().nullish(),
  allowMultipleAnswer: z.optional(z.boolean()),
  showComment: z.optional(z.boolean()),
  answersCount: z.optional(z.number().int()),
  classStart: z.string().datetime().nullish(),
  classEnd: z.string().datetime().nullish(),
}) as unknown as ToZod<FeedbackDetailViewModel>;
